import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { checkInvalid } from 'src/app/validation';
import { errorMessages } from 'src/message/error';
import { Router } from '@angular/router';
import { AppURL } from 'src/app/app.url';
import { LoadingScreenService } from '@app-services/loading-screen.service';
import { AlertMessageComponent } from '../../components/modals/alert-message/alert-message.component';
import { __exportStar } from 'tslib';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  fg: FormGroup;
  _e = errorMessages.TH;
  authenFailed = false;
  authenFailMessage = this._e.authenWrongCred;
  alertDialogRef: MatDialogRef<AlertMessageComponent>;

  @ViewChild('form') formElementRef: ElementRef;

  constructor(
    public dialog: MatDialog,
    private loadingScreenService: LoadingScreenService,
    private authSer: AuthService,
    private _fb: FormBuilder,
    private _router: Router
  ) { }

  ngOnInit() {
    // TODO: Get email and rememberMe from cookies if any
    this.fg = this._fb.group({
      email: [null, [Validators.required, Validators.email]],
      password: [null, [Validators.required]],
      rememberMe: [false]
    });


  }

  forgotPassword() {
    if (this.fg.get('email').value === '') {
      this.fg.get('email').setErrors({ 'required': true });
      this.fg.get('email').markAsTouched();
    } else if (this.fg.get('email').getError('email')) {
      // invalid email format
    } else {
      this.loadingScreenService.startLoading();
      this.authSer.resetPassword(this.fg.get('email').value).then(
        (value: any) => {
          this.loadingScreenService.stopLoading();
          // this.authenFailed = true;
          // this.authenFailMessage = this._e.loginCheckYourEmail;
          this.alertDialogRef = this.dialog.open(AlertMessageComponent, {
            width: '450px',
            height: '380px',
            data: { header: this._e.loginAlertHeader,
                    message: this._e.loginCheckYourEmail },
          });
        }
      ).catch((error: any) => {
        console.log(error);
        // this.authenFailed = true;
        switch (error.code) {
          case 'auth/invalid-email' :
            this.authenFailed = false;
            this.fg.get('email').setErrors({ 'email': true });
            this.fg.get('email').markAsTouched();
          break;
          case 'auth/user-disabled' :
            this.authenFailed = true;
            this.authenFailMessage = this._e.authenDisabled;
          break;
          case 'auth/user-not-found' :
            this.authenFailed = false;
            this.fg.get('email').setErrors({ 'emailDidNotFound': true });
            this.fg.get('email').markAsTouched();
          break;
          case 'auth/argument-error' :
            this.authenFailed = false;
            this.fg.get('email').setErrors({ 'required': true });
            this.fg.get('email').markAsTouched();
          break;
          default:
          break;
        }
        this.loadingScreenService.stopLoading();
      }).finally(() => { this.loadingScreenService.stopLoading(); });
    }
  }

  login() {
    if (!checkInvalid([this.fg], this.formElementRef, true)) {
      // TODO: Save/clear email and remember in cookies

      this.loadingScreenService.startLoading();
      this.authSer.authen(
        this.fg.get('email').value,
        this.fg.get('password').value,
        this.fg.get('rememberMe').value).then(
          (value: any) => {
            this._router.navigate([AppURL.MainPage]);
          }
        ).catch((error: any) => {
          console.log(error);
          this.authenFailed = true;
          if (error.code === 'auth/user-disabled') {
            this.authenFailMessage = this._e.authenDisabled;
          } else {
            this.authenFailMessage = this._e.authenWrongCred;
          }
        }).finally(() => { this.loadingScreenService.stopLoading(); });
    }
  }
}
